import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Select } from "antd";

import "./customStyle.css";

const { Option } = Select;

class FormOne extends React.Component {
  render() {
    const { onSubmit, form, hotelGetData, hmgGetData, hmgMainGetData } =
      this.props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

    const hmgIdValue = getFieldValue("hmg_id");
    const hmgMainIdValue = getFieldValue("hmg_main_id");

    const hmgMainIdOnChange = (value) => {
      setFieldsValue({ hmg_id: undefined });
      setFieldsValue({ hotel_name: undefined });
      this.props.formOneHmgMainIdOnChange(value);
    };

    const hmgIdOnChange = (value) => {
      const result = hmgGetData.find((e) => e._id === value);
      if (result) {
        setFieldsValue({ hmg_main_id: result.hmg_id });
      }
      setFieldsValue({ hotel_name: undefined });
      this.props.formOneHmgIdOnChange(value);
    };

    const foremOneHotelOnChangeNew = (value) => {
      this.props.foremOneHotelOnChange(value, hmgIdValue);
      // const result = hotelGetData.find(
      //   (e) => e._id === value
      // );
      // if(result){
      //   setFieldsValue({hmg_id : result.primary_hmg_id});
      //   const result2 = hmgGetData.find(
      //     (e) => e._id === result.primary_hmg_id
      //   );
      //   if(result2){
      //     setFieldsValue({hmg_main_id : result2.hmg_id});
      //   }
      // }
    };

    const hmgMainOptions = hmgMainGetData
      .sort((a, b) => a.hmg_name.localeCompare(b.hmg_name))
      .map((d) => <Option key={d._id}>{d.hmg_name}</Option>);
    const hmgOptions = hmgGetData
      .filter((item) => {
        if (hmgMainIdValue) {
          if (item.hmg_id === hmgMainIdValue) {
            return true;
          }
          return false;
        }
        return false;
      })
      .sort((a, b) => a.project_name.localeCompare(b.project_name))
      .map((d) => <Option key={d._id}>{d.project_name}</Option>);

    const hotelOptions = hotelGetData
      .filter((item) => {
        if (hmgIdValue) {
          if (
            item.primary_hmg_id === hmgIdValue ||
            item.secondary_hmg_id === hmgIdValue ||
            item.third_hmg_id === hmgIdValue ||
            item.fourth_hmg_id === hmgIdValue
          ) {
            return true;
          }
          return false;
        }
        return false;
      })
      .sort((a, b) => a.hotel_code.localeCompare(b.hotel_code))
      .map((d) => (
        <Option key={d._id}>
          {d.hotel_code} -{d.hotel_name}
        </Option>
      ));
    const formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
        lg: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 },
        lg: { span: 10 },
      },
    };
    const formItemStyles = {
      style: {
        marginBottom: 0,
      },
    };
    const buttonStyles = {
      wrapperCol: { span: 12, offset: 6 },
    };
    const dropdownStyles = {
      style: { maxWidth: 450 },
    };

    return (
      <Form onSubmit={onSubmit} {...formLayout}>
        <Form.Item label="Hotel Management Group" {...formItemStyles}>
          {getFieldDecorator("hmg_main_id", {
            rules: [
              {
                required: true,
                message: "Please Enter Hotel Management Group",
              },
            ],
          })(
            <Select
              allowClear
              showSearch
              placeholder="Enter Hotel Management Group"
              onChange={hmgMainIdOnChange}
              optionFilterProp="children"
              // notFoundContent={null}
              {...dropdownStyles}
            >
              {hmgMainOptions}
            </Select>,
          )}
        </Form.Item>

        <Form.Item label="Project Name" {...formItemStyles}>
          {getFieldDecorator("hmg_id", {
            rules: [
              {
                required: true,
                message: "Please Enter Project Name",
              },
            ],
          })(
            <Select
              allowClear
              showSearch
              placeholder="Enter Project Name"
              onChange={hmgIdOnChange}
              optionFilterProp="children"
              // notFoundContent={null}
              {...dropdownStyles}
              disabled={getFieldValue("hmg_main_id")? false : true }
            >
              {hmgOptions}
            </Select>,
          )}
        </Form.Item>

        <Form.Item label="Hotel Name" {...formItemStyles}>
          {getFieldDecorator("hotel_name", {
            rules: [
              {
                required: true,
                message: "Please Enter Hotel Name",
              },
            ],
          })(
            <Select
              showSearch
              placeholder="Enter Hotel Name"
              onChange={foremOneHotelOnChangeNew}
              optionFilterProp="children"
              // notFoundContent={null}
              {...dropdownStyles}
              disabled={getFieldValue("hmg_id")? false : true }
            >
              {hotelOptions}
            </Select>,
          )}
        </Form.Item>

        <Form.Item {...buttonStyles}>
          <Button type="primary" htmlType="submit">
            Select
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_one" })(FormOne);

export default WrappedApp;
